module.exports = __webpack_public_path__ + "img/artillery-wagon-base-8.9fc9ed5a.png";